import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=6eb4ed17&scoped=true"
import script from "./appointment.vue?vue&type=script&lang=js"
export * from "./appointment.vue?vue&type=script&lang=js"
import style0 from "./appointment.vue?vue&type=style&index=0&id=6eb4ed17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb4ed17",
  null
  
)

export default component.exports